import {useLoaderData} from '@remix-run/react'
import type {CategoriesDataProps} from '~/types'
import Articles from './articles-section'
import Header from './header'
import Metrics from './metrics-section'
import TopLists from './top-lists-section'
import TopRatedDiscounts from './top-rated-discounts-section'

const ImprovedHomepage = () => {
  const {improvedHomepageData} = useLoaderData() as CategoriesDataProps
  const {articles = [], topDiscounts = [], topLists = []} = improvedHomepageData || {}

  return (
    <div className="w-full overflow-hidden bg-white">
      <Header />
      <div className="mt-5 flex flex-col gap-y-9">
        {topLists.length > 0 && <TopLists topLists={topLists} />}
        {topDiscounts.length > 0 && <TopRatedDiscounts topRatedDiscounts={topDiscounts} />}
        <Metrics />
        <Articles articles={articles} />
      </div>
    </div>
  )
}

export default ImprovedHomepage
